import { ReactNode } from "react";

import {
    ResultPanelBlock,
    ResultsPanelBlocks
} from "@/components/Search/SearchBar/ResultsPanel/resultsPanel.templates";

type ResultsPanelComponentProps = {
    blocks: ResultsPanelBlocks;
    noResults: ReactNode;
};

const ResultsPanelComponent = ({
    blocks,
    noResults
}: ResultsPanelComponentProps) => {
    return (
        <>
            {noResults}
            {!noResults && (
                <>
                    <div>
                        {blocks[ResultPanelBlock.RECENT_SEARCHES]}
                        {blocks[ResultPanelBlock.QUERY_SUGGESTIONS]}
                        {blocks[ResultPanelBlock.CONTENT_PAGES]}
                    </div>
                    <div>{blocks[ResultPanelBlock.PRODUCTS]}</div>
                </>
            )}
        </>
    );
};

export { ResultsPanelComponent };
